import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66d16246"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("img", {
    class: _normalizeClass(["app-icon", _ctx.iconClass]),
    width: _ctx.width,
    height: _ctx.height,
    alt: _ctx.type
  }, null, 10, _hoisted_1))
}